import { Controller } from "@hotwired/stimulus"
import LeaderLine from "leader-line-new"
// Connects to data-controller="editor--multi-inapp--lines"
export default class extends Controller {
  connect() {
    this.lines = []
    // Workaround : connect is called when tree is re-rendered -> recalculate here
    document.dispatchEvent(new CustomEvent("updateProjectSize"))

    this.boundRedrawLines = this.redrawLines.bind(this)
    document.addEventListener("redrawLines", this.boundRedrawLines)
  }

  disconnect() {
    // Clean up lines when controller is disconnected
    this.removeLines()

    // Remove event listener
    if (this.boundRedrawLines) {
      document.removeEventListener("redrawLines", this.boundRedrawLines)
    }
  }

  drawLines() {
    let branches = document.querySelectorAll(".tree-branch")
    branches.forEach((branch) => {
      let start = branch
      let inappId = branch.dataset.inappId

      // Ensure start element is connected to the document
      if (!start.isConnected) {
        return
      }

      // Don't draw lines to sections with no buttons
      let ends = document.querySelectorAll(`.transitions-inapp-${inappId}:has(.transition-button)`)

      ends.forEach((end) => {
        // Ensure both elements are connected to the document before creating line
        if (!end.isConnected || !start.isConnected) {
          return
        }

        try {
          var line = new LeaderLine(start, end, {
            color: "#C4C4C4",
            size: 2,
            startSocket: "bottom",
            endSocket: "top",
            path: "grid",
            endPlug: "behind",
          })
          this.lines.push(line)
        } catch (e) {
          console.debug('Error creating line:', e)
        }
      })
    })

    // Move lines to tree view
    document.querySelectorAll(".leader-line").forEach((line) => {
      document.getElementById("tree").appendChild(line)
    })
  }

  removeLines() {
    // First, remove all DOM elements to prevent LeaderLine from accessing them
    document.querySelectorAll(".leader-line").forEach((lineElement) => {
      try {
        if (lineElement.parentNode) {
          lineElement.remove()
        }
      } catch (e) {
        // Silently handle already-removed elements
      }
    })

    // Then destroy LeaderLine instances to clean up event listeners
    if (this.lines && this.lines.length > 0) {
      this.lines.forEach((line) => {
        if (line) {
          try {
            // Call remove() to clean up event listeners and internal state
            line.remove()
          } catch (e) {
            // Silently catch errors - DOM elements are already removed
          }
        }
      })
    }
    this.lines = []
  }

  redrawLines() {
    // Only redraw if the tree element exists
    const tree = document.getElementById("tree")
    if (!tree) {
      this.lines = []
      return
    }

    window.scrollTo(0, 0)
    this.removeLines()
    this.drawLines()
  }
}
